import { ReactComponent as KioskIconSVG } from 'assets/svg/kiosk-icon.svg';
import styled from 'styled-components';

export const KioskIcon = styled(KioskIconSVG)`
  width: 23px;
  color: ${({ theme }) => theme.colors.silver400};
  margin-right: 4px;
`;
